<template>
    <div class="snapshot">
        <h2 class="snapshot-header font Roboto f-s-36 f-w-700 l-h-40 l-t-s-75">
            Snapshot of Our Community
        </h2>
        <div class="snapshot-container">
            <div class="">
                <img :src="$image('community/consumer-community.png')" alt="Consumer community" class="w-100">
            </div>
            <div class="snapshot-items">
                <div class="row">
                    <div v-for="(snapshot, i) in snapShots" :key="i" class="col-6 m-b-32">
                        <SnapShotItem :snapshot="snapshot" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import SnapShotItem from '~/components/common/community/snapshot/SnapShotItem';

const snapShots = [
    {
        image: 'community/briefcase.png',
        value: '80',
        title: 'Working Professionals',
        sub_title: null,
    },
    {
        image: 'community/carriage.png',
        value: '44',
        title: 'Have Kids at Home',
        sub_title: '',
    },
    {
        image: 'community/doggo.png',
        value: '44',
        title: 'Pet Owner',
        sub_title: '',
    },
    {
        image: 'community/graduationHat.png',
        value: '70',
        title: 'College Degree',
        sub_title: '',
    },
    {
        image: 'community/dumbbell.png',
        value: '52',
        title: 'Physically Active',
        sub_title: '',
    },
    {
        image: 'community/apple.png',
        value: null,
        title: 'Health Conscious',
        sub_title: 'Prioritizing natural and clean alternatives',
    },
    {
        image: 'community/blueEarth.png',
        value: null,
        title: 'Broad Representation',
        sub_title: 'Reflecting the US & Canada',
    },
    {
        image: 'community/shoppingCart.png',
        value: null,
        title: 'Diverse Diets',
        sub_title: 'A melting pot of niche dietary preferences and habits',
    },
];

export default {
    components: {
        SnapShotItem,
    },
    data() {
        return {
            snapShots,
        };
    },
};
</script>

<style lang="scss" scoped>
.snapshot {
    padding: 40px 0;
    &-container {
        display: flex;
        flex-flow: column;
    }

    &-header {
        text-align: left;
    }

    @media (max-width: 768px) {
        &-image {
            &-container {
                width: 100%;
            }
        }

        &-header {
            text-align: center;
            margin-bottom: 40px;
        }

    }

    @media only screen and (min-width: 992px) {

        &-container {
            gap: 32px;
            align-items: center;
            flex-flow: inherit;
        }

        &-items {
            max-width: 632px;
        }

        &-header {
            text-align: center;
            margin-bottom: 40px;
        }
    }
}
</style>
